export default {
    positionStackedChart: {
        forecastBaseline: 'Osnovna napoved',
        thisContract: 'Ta pogodba',
        otherFutures: 'Drugi futures',
        finalPosition: 'Končna pozicija',
        ariaLabel:
            'Grafikon zložene pozicije: osnovna napoved, ta pogodba, drugi futures in črta končne pozicije',
        tableBucket: 'Interval',
        tableForecast: 'Napoved',
        tableFinal: 'Končno',
    },
}
